import { initReferral } from './26-brand-day-earn-referral.js?v=2026090101747';
import { BdeReferralHistory } from './26-brand-day-earn-history.js?v=2026090101747';
import { BdeTaskPanel } from './26-brand-day-earn-task-panel.js?v=2026090101747';
import { BdeTabsSection } from './26-brand-day-earn-tabs.js?v=2026090101747';

if (!customElements.get('bde-tabs-section')) {
  customElements.define('bde-tabs-section', BdeTabsSection);
}
if (!customElements.get('bde-task-panel')) {
  customElements.define('bde-task-panel', BdeTaskPanel);
}
if (!customElements.get('bde-referral-history')) {
  customElements.define('bde-referral-history', BdeReferralHistory);
}

function initBdeSections(selection) {
  const sections = selection.matches?.('.bde-section')
    ? [selection]
    : selection.querySelectorAll('.bde-section');

  sections.forEach((section) => {
    initReferral(section);
  });
}

initBdeSections(document);

document.addEventListener('shopify:section:load', (event) => {
  initBdeSections(event.target);
});
